<div class="card-v2 bg-theme-white relative">
  <div class="absolute -top-4 right-8">
    <img src="assets/images/svg-illustrations/flags/flag{{ (index % 3) + 1 }}.svg" alt="" />
    <div
      [innerHTML]="featuredTestimony.rank | rank"
      class="absolute top-0 bottom-6 left-4 right-0 text-theme-white flex items-center justify-center text-26"
    ></div>
  </div>

  <div class="p-8 flex items-center space-x-8 bg-site-theme-main-five rounded-t pr-[80px]">
    <app-round-cover-image
      [src]="featuredTestimony.picture"
      [size]="60"
      class="shrink-0"
    ></app-round-cover-image>

    <div class="grow overflow-hidden space-y-2">
      <div class="truncate text-18 font-semibold">
        {{ featuredTestimony.firstName }}
      </div>
      <div class="truncate text-13 font-light">
        {{ featuredTestimony.ecnRank }}
      </div>
    </div>
  </div>

  <div class="p-8 grow bg-theme-white rounded-b">
    <div
      class="text-theme-gray-nine italic text-13 leading-relaxed innerHtml"
      [innerHTML]="featuredTestimony.content"
    ></div>
  </div>
</div>
